import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Graph from '../../components/Graph';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaPrint } from 'react-icons/fa';
import { FaCalendarAlt,
         FaWalking,
         FaBicycle,
         FaMotorcycle,
         FaCarSide,
         FaShuttleVan,
         FaTruckPickup,
         FaTruck,
         FaBus,
         FaTruckMoving,
         FaRegQuestionCircle
        } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import DatePicker from 'react-multi-date-picker';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import moment from 'moment';
import DataReportVehTrendXls from './DataReportVehTrendXls';

import { useToasts } from 'react-toast-notifications';

import "./DataReportVehTrend.scss";

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const DataReportTrend = (props) => {
    const { addToast } = useToasts();
    const arrMonth = ['Jan', 'Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    const [vehicleCount, setVehicleCount] = useState({});
    const [vehicleCountTbl, setVehicleCountTbl] = useState([]);
    const [asset, setAsset] = useState();
    const [assets, setAssets] = useState([]);
    const [assetName, setAssetName] = useState();
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState([new Date()]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);
    const [vehClass, setVehClass] = useState('PEDESTRIAN');
    // const [mnthSel, setMnthSel] = useState(arrMonth.slice(0,(new Date()).getMonth() ));
    const [mnthSel, setMnthSel] = useState(arrMonth);

	const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
    const chartColors = process.env.REACT_APP_CHART && process.env.REACT_APP_CHART.split(',');  
    const [error, setError] = useState('');

    let vClass = process.env.REACT_APP_CLASS && process.env.REACT_APP_CLASS.split(',');    
    vClass = vClass.map(i => i.trim())


    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            const data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)

            //Get user asset list
            // let user_assets = []
            // if (props.user && props.user.username)
            //     user_assets = await API.get('user_assets','/' + props.user.username, params)
            let user_assets = props.user.user_assets || []

            let assetsFiltered = []
            if (user_assets){
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id) && x.status === 'active');
            }

            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

        if (props.user && props.user.user_assets)
            fetchAssets();

    }, [props.user]);

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true);
        setCounts([]);

        let result = []

        dateSel && dateSel.sort((a, b) => (a > b) ? 1 : -1)

        for (let i = 0; i < dateSel.length; i++){
            
            const YYYY = (new Date(dateSel[i])).getFullYear()
            const dateFrom = new Date(YYYY, 0, 1)
            const dateTo = new Date(YYYY, 11, 31)

            const dtFrom = moment.utc(dateFrom).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

            const dtTo = moment.utc(dateTo).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();

            // console.log(dateStart)
            // console.log(dateEnd)

            let data = []
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd +'&class='+ vehClass

                await API.get('daily_class_counts','/'+ filter, params)
                .then(resp => {
                    data = resp
                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                    setIsLoadingCounts(false);
                });

                result.push(data)

            } else {
                addToast('Error incorrect dates', { appearance: 'error' });
            }
        }
        // console.log(result)
        const selAsset = assets.find(x => x.id === asset)
        setAssetName(selAsset.name);
        setCounts(result);
        setIsLoadingCounts(false);

    }

    // // Load location
	// useEffect(()=>{
	// 	const fetchLocation = async () => {
    //         const loc = [...new Set(assets.map(item => item.location))];
	// 		setLocationList(loc);
    //         if (loc.length === 1)
    //             setLocation(loc[0]);
	// 	}
    //     fetchLocation();
    // }, [assets]);

   // Load country
   useEffect(()=>{
    const fetchCountry = async () => {
        let loc = [...new Set(assets.map(item => item.country))];
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        if (loc.length === 1)
            setCountry(loc[0]);

        setCountryList(loc);
    }
    fetchCountry();

    }, [assets]);

    // Load location
    useEffect(()=>{
    const fetchLocation = async () => {
        let loc=[]
        if (country){
            loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
        }else{
            loc = [...new Set(assets.map(item => item.location))];
        }
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        setLocationList(loc);
    }
    fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            setAssetList(results);
        }
		handleSearch();
    }, [location, country, assets]);


    const hex2rgba = (hex, alpha = 1) => {
        const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
      };

    // VEHICLE COUNT START
    // --------------------------
    useEffect(() => {

        // Total vehicles count / hour
        const getVehicleCount = () => {

        let dataSet = [];
        let vehCount = [];
        let arrVeh = [];

        // console.log(counts)
        for (let j=0; j < counts.length; j++){
            let color = chartColors[(Math.floor(Math.random() * chartColors.length))]
            let data = counts[j]
            let yy = (new Date(dateSel[j])).getFullYear()
           

            for (let i=0; i < arrMonth.length; i++){

                let dataMonth = []

                dataMonth = data.length>0 && data.filter(function(item){
                    let aDate = moment(new Date(item.date_iso)).format('MM');
                    return parseInt(aDate) === i+1;
                })

                const arrLength = arrMonth.length
                arrVeh = dataMonth && dataMonth.map((item, i) => item.volume)
                                .reduce((r, a) => a.map((b, i) => (r[i] || 0) + b), [])
                                .map(item => Math.round(item/arrLength) || 0)

                // Monhtly Graph
                // dataSet.push({
                //     type: 'bar',
                //     label: arrMonth[i] + " " + (new Date(dateSel[j])).getFullYear(),
                //     data: arrVeh,
                //     backgroundColor: chartColors[j],                 
                // })

                // console.log("INSERT MONTH >>", arrMonth[i])
                // Table detail
                vehCount.push({
                    date: arrMonth[i],
                    counts: arrVeh,
                    year: yy,
                    color: hex2rgba(color, 0.4)
                })
            }
        

            // Filter selected months
            // dataSet = dataSet.filter(item => mnthSel.includes(item.label));     
            arrVeh = [];
            vehCount = vehCount.filter(item => (mnthSel.includes(item.date) && item.counts.length>0) || item.date==="Trend ");    

            const vehYY = vehCount.filter(item => item.year ===yy).length
            arrVeh = vehCount.filter(item => item.year ===yy).map(item => item.counts).reduce(function (r, a) {
                                                a!==false &&
                                                a.forEach(function (b, i) {
                                                    r[i] = (r[i] || 0) + b;
                                                })
                                                return r;
                                            }, [])
                                .map(item => Math.round(item/vehYY) || 0)
 
 
        //Trend Graph
        dataSet.push({
            type: 'line',
            label: yy,
            data: arrVeh,
            borderColor: color, // chartColors[2], //'rgba(255, 99, 132, 1)',
            fill: false,
            borderWidth: 2,
            stack: j
        })

        // Trend table details
        vehCount.push({
            date: "Trend ",
            counts: arrVeh,
            year: yy,
            color
        })  
    }



        // Graphs => bar: avg daily counts by month / line: avg annual trend
        const data = {
            labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                    ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                    ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                    ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                    ],
            datasets: dataSet,
            stepped: true,
        }
        setVehicleCount(data);
        setVehicleCountTbl(vehCount);
        }

        getVehicleCount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts]);
    // VEHICLE COUNT END

    // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        plugins: { 
            datalabels: { display: false }
        }
    };

    const handleClearSearch = () => {
		setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
		setAsset('');
		setDateSel(new Date());
        // setMnthSel(arrMonth.slice(0,(new Date()).getMonth()));
        setMnthSel(arrMonth);
        setCounts([]);
        setVehClass('PEDESTRIAN');
        // if (locationList.length === 1)
        //     setLocation(locationList[0]);
        // else
        //     setLocation('');
        if (countryList.length === 1)
            setCountry(countryList[0]);
        else
            setCountry('');
        setLocation('');
        setError('');
    }

    const handleSearch = () => {
        if (asset){
            fetchCounts();
        }else{
            setError("Required");
        }
    }

    const startTime = new Date();
    startTime.setHours(23,59,0);
    const handleMnthChange = (val) => setMnthSel(val);

    return (

        <div className="DataReportVehTrend">
            <div className="col-md-12">
                <div className="row header">Vehicle Detector Annual Trend</div>
            </div>
            {(!isLoading) ? (
            <div>
            <div className="col-md-12 pt-0 div-content">
            <div className="row">
                <div className="col-12 p-2 d-flex rounded bg-light">
                    <div className="col-8">
                    <div className="row">
                        <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-4">
                            <Form.Group controlId="country">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={country}
                                    onChange={e => {setCountry(e.target.value)}}>
                                        <option value="">Country</option>
                                        {countryList.map((item, i) =>
                                            <option key={`country`+i} value={item}>{item}</option>
                                            )}

                                </Form.Control>
                            </Form.Group>
                            </div>
                            <div className="col-md-8">
                            <Form.Group controlId="location" >
                            <Form.Label>Location</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => {setLocation(e.target.value)}}>
                                        <option key='locs' value=''>Location</option>
                                        {locationList.map((item, i) =>
                                            <option key={`loc`+i} value={item}>{item}</option>
                                            )}
                                </Form.Control>
                            </Form.Group>
                            </div>
                            </div>
                            <Form.Group controlId="asset" >
                                <Form.Label>Asset</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={asset}
                                    onChange={e => {
                                        setError("");
                                        setAsset(e.target.value);}}
                                    >
                                    <option key='assetList' value=''>Select Asset</option>
                                    {assetList.map((item, i) =>
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                    )}
                                </Form.Control>
                                <div className="error-message">{error}</div>
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group controlId="date_from" className="pb-0 mb-1">
                            <Form.Label><FaCalendarAlt className="text-secondary" /> Select Year(s)</Form.Label>
                            <div>
                            <DatePicker
                                multiple
                                value={dateSel}
                                onChange={setDateSel}
                                minDate='2021'
                                maxDate={new Date()}
                                plugins={[
                                    <DatePanel sort="date"/>
                                   ]}
                                inputClass="form-control"
                                onlyYearPicker
                                />
                            </div>
                            </Form.Group>
                            <div className="pb-2">
                            <ToggleButtonGroup type="checkbox" name="optionsMnth" id="btn-veh" value={mnthSel} onChange={handleMnthChange} >
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Jan">
                                   Jan
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Feb">
                                    Feb
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Mar">
                                    Mar
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Apr">
                                    Apr
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="May">
                                    May
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Jun">
                                    Jun
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Jul">
                                    Jul
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Aug">
                                    Aug
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Sep">
                                    Sep
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Oct">
                                    Oct
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Nov">
                                    Nov
                                </ToggleButton>
                                <ToggleButton variant="outline-secondary" className="class-mnth" value="Dec">
                                    Dec
                                </ToggleButton>
                            </ToggleButtonGroup>
                            </div>
                            <div >
                            <ToggleButtonGroup type="radio" name="options" id="btn-veh" value={vehClass} >
                                <ToggleButton variant="outline-warning" className="class" value="PEDESTRIAN" onClick={() => setVehClass('PEDESTRIAN')} >
                                    <OverlayTrigger key="ped" placement="bottom"
                                        overlay={<Tooltip id='tooltip-ped' className="class-tooltip">Pedestrian</Tooltip>}>
                                    <FaWalking />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="BIKE" onClick={() => setVehClass('BIKE')}>
                                    <OverlayTrigger key="bike" placement="bottom"
                                        overlay={<Tooltip id='tooltip-bike' className="class-tooltip">Bike</Tooltip>} >
                                        <FaBicycle />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="MOTORBIKE" onClick={() => setVehClass('MOTORBIKE')}>
                                    <OverlayTrigger  key="motorbike" placement="bottom"
                                        overlay={<Tooltip id='tooltip-motorbike' className="class-tooltip">Motorbike</Tooltip>}>
                                        <FaMotorcycle />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="CAR" onClick={() => setVehClass('CAR')}>
                                    <OverlayTrigger key="car" placement="bottom"
                                        overlay={<Tooltip id='tooltip-car' className="class-tooltip">Car</Tooltip>}>
                                        <FaCarSide />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="VAN" onClick={() => setVehClass('VAN')}>
                                    <OverlayTrigger key="van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-van' className="class-tooltip">Van</Tooltip>} >
                                        <FaShuttleVan />
                                    </OverlayTrigger>
                                </ToggleButton>
                                <ToggleButton variant="outline-warning" className="class" value="SHORT TRUCK" onClick={() => setVehClass('SHORT TRUCK')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Short Truck</Tooltip>} >
                                        <FaTruck />
                                    </OverlayTrigger>
                                </ToggleButton>
                                {vClass.find(x => x === 'Med Truck') ? 
                                <ToggleButton variant="outline-warning" className="class" value="MED TRUCK" onClick={() => setVehClass('MED TRUCK')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Med Truck</Tooltip>} >
                                        <FaTruckPickup />
                                    </OverlayTrigger>
                                </ToggleButton>
                                :''}
                                <ToggleButton variant="outline-warning" className="class" value="LONG TRUCK" onClick={() => setVehClass('LONG TRUCK')}>
                                    <OverlayTrigger key="truck" placement="bottom"
                                        overlay={<Tooltip id='tooltip-truck' className="class-tooltip">Long Truck</Tooltip>} >
                                        <FaTruckMoving />
                                    </OverlayTrigger>
                                </ToggleButton>
                                {vClass.find(x => x === 'Bus') ? 
                                <ToggleButton variant="outline-warning" className="class" value="BUS" onClick={() => setVehClass('BUS')}>
                                    <OverlayTrigger key="large-van" placement="bottom"
                                        overlay={<Tooltip id='tooltip-large-van' className="class-tooltip">Bus</Tooltip>} >
                                        <FaBus />
                                    </OverlayTrigger>
                                </ToggleButton>
                                :''}
                                <ToggleButton variant="outline-warning" className="class" value="UNDEFINED" onClick={() => setVehClass('UNDEFINED')}>
                                    <OverlayTrigger key="undefined" placement="bottom"
                                        overlay={<Tooltip id='tooltip-undefined' className="class-tooltip">Undefined</Tooltip>}>
                                        <FaRegQuestionCircle />
                                    </OverlayTrigger>
                                </ToggleButton>
                            </ToggleButtonGroup>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="text-nowrap">

                        <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap"
                        disabled = {isLoadingCounts? true : false}
                        >
                            <MdSearch /> Search
                        </Button>

                        <Button variant="danger" size="sm" onClick={handleClearSearch} >
                            <MdClear />
                        </Button>

                    </div>
                    <div className="w-100 text-right print">
                        <DataReportVehTrendXls
                            vehCount={vehicleCountTbl}
                            vehClass={vehClass}
                            dateFrom={dateSel}
                            asset={assetName}
                            />
                        <Button variant="light" size="sm" onClick={() => window.print()} >
                            <FaPrint /> Print
                        </Button>
                    </div>
                </div>
                </div>

                <div className="row p-2">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4"><h2 className="text-info">Vehicle Count - {vehClass}</h2></div>
                            <div className="col-md-4 text-center">
                            {(isLoadingCounts) ? (
                            <>
                            <Spinner animation="grow" size="sm" role="status" variant="warning" />
                            <span className="text-secondary">  Loading...</span>
                            </>
                         ): ''}
                            </div>
                            <div className="col-md-4 pb-2 small text-right text-secondary">
                                {/* &nbsp;&nbsp;Last Update: {lastUpd} */}
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-md-12">
                            {(vehicleCount.datasets && vehicleCount.datasets.length > 0)?
                            <Graph
                                title="Vehicle Count"
                                data={vehicleCount}
                                options={options}
                                site={assetName}
                            />
                            :''}
                            </div>

                            <div className="col-md-12 pt-3" key="tbl_det">
                            <Table responsive hover className="small p-0 border">
                            <thead>
                                <tr>
                                    <th className='table-th'>Year</th>
                                    <th className='table-th'>Month</th>
                                    {[...Array(24)].map((x, i) =>
                                    <th className='table-th' key={"m"+i}>{i+":00"}<br/>{(i+1)+":00"}</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                            {vehicleCountTbl.map((item,i) =>
                             item.counts.length>0 ?
                                <tr key={"tr-det-"+i} className="table-tr">
                                    <td key={"td-det-year"+i} className="table-th" style = {{backgroundColor: item.color }} ><strong>{item.year}</strong></td>
                                    <td key={"td-det-date"+i} className="table-th" ><strong>{item.date}</strong></td>
                                    {item.counts.map((count,j) =>
                                    <td key={"td-det-"+j} className={(i===vehicleCountTbl.length-1)?'table-td-bold':'table-td'}>{count}</td>
                                    )}
                                </tr>
                             :<tr key={"tr-det-"+i} className="table-tr"><td></td></tr>
                            )}
                            </tbody>
                            </Table>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            </div>
            ):(
                <div className="col-md-12">
                <Spinner animation="grow" size="sm" role="status" variant="warning" />
                <span className="text-dark">  Loading...</span>
                </div>
                )}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
  };

export default connect(mapStateToProps)(DataReportTrend);


